import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentType',
})
export class PaymentTypePipePipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 0: {
        return '';
      }
      case 1: {
        return 'PROFILE.PAYMENT_METHOD_BILL';
      }
      case 2: {
        return 'PROFILE.PAYMENT_METHOD_PAYONE';
      }
    }
    return 'Error';
  }
}
